interface Props {
  providerName: string;
  lastUpdate: string;
}
export const ProviderName: React.FC<Props> = ({providerName,lastUpdate})=>{
  return (
    <div className="flex flex-1 justify-between gap-x-4">
      <div className="text-sm w-[81px]">{providerName}:</div>
      <div className="text-text-secondary text-sm">{lastUpdate}</div>
    </div>
  )
}